<main class="login-page" dir="rtl">
  <div class="login-shell">
    <div class="login-card">
      <div class="login-header">
        <div>
          <span class="login-brand">راهداری GPS</span>
          <h1>ورود کارشناس</h1>
        </div>
        <a class="close-button" routerLink="/home" aria-label="بازگشت به صفحه اصلی">
          <mat-icon aria-hidden="true">close</mat-icon>
        </a>
      </div>

      <div class="login-body">
        <p class="form-intro">اطلاعات خود را برای ورود وارد کنید.</p>
        <label for="specialist-mobile">شماره موبایل</label>
        <div class="form-group has-icon" [class.direction-ltr]="phoneNumberField.value">
          <span class="form-control-icon"><mat-icon aria-hidden="true">phone_iphone</mat-icon></span>
          <input id="specialist-mobile" type="tel" class="form-control" [disabled]="isSubmitDisabled"
            #phoneNumberField="ngModel" [(ngModel)]="fields.strMobile" required appPhoneNumberValidation
            [maxLength]="11" [minlength]="11" inputmode="numeric" autocomplete="tel" appNumericOnly
            placeholder="شماره موبایل" />
        </div>

        <label for="specialist-password">رمز عبور</label>
        <div class="form-group has-icon">
          <span class="form-control-icon"><mat-icon aria-hidden="true">lock_outline</mat-icon></span>
          <input id="specialist-password" type="password" class="form-control" [disabled]="isSubmitDisabled"
            #passwordField="ngModel" [(ngModel)]="fields.strUserPassword" required autocomplete="current-password"
            placeholder="رمز عبور" (keydown.enter)="submit(phoneNumberField, passwordField)" />
        </div>

        <button type="button" class="forgot-button"
          [disabled]="phoneNumberField.invalid || phoneNumberField.pristine || isSubmitDisabled"
          (click)="forgetPassword(phoneNumberField)">فراموشی رمز عبور</button>
      </div>

      <div class="login-footer">
        <button type="button" class="submit-button"
          [disabled]="phoneNumberField.invalid || passwordField.invalid || phoneNumberField.pristine || passwordField.pristine || isSubmitDisabled"
          (click)="submit(phoneNumberField, passwordField)">ورود</button>
      </div>
    </div>
  </div>
</main>
